import React from 'react';
import cx from 'classnames';

import Mp4GifEmulator from 'components/common/ui/Mp4GifEmulator';

import ConfigureAddressCollectionFormValues from 'components/manage/guestlist/addressCollection/@types/formValues';
import { ConfigureAddressCollectionPreviewStateProps } from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionPreview';

import styles from './ConfigureAddressCollectionPreview.module.less';

type ConfigureAddressCollectionPreviewProps = ConfigureAddressCollectionPreviewStateProps & {
  previewData: ConfigureAddressCollectionFormValues;
  className?: string;
};

const ConfigureAddressCollectionPreview: React.FC<ConfigureAddressCollectionPreviewProps> = ({
  previewData: { linkTitle, showWeddingDate, weddingDate },
  guestCollectionImg,
  tempImg,
  className,
}) => {
  const imageUrl = tempImg?.url || guestCollectionImg;
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.phoneBg}>
        <div className={styles.message}>
          {imageUrl ? (
            <img className={styles.img} src={imageUrl} alt="Guest address collection preview" />
          ) : (
            <Mp4GifEmulator
              src={`${process.env.PUBLIC_URL}/static-preauth/images/AddressCollection/weDo.mp4`}
              className={styles.img}
            />
          )}
          <div className={styles.textContainer}>
            {linkTitle || 'Can you tap and share your address? 😉 Xo'}{' '}
            {showWeddingDate && weddingDate}
            <div className={styles.zola}>zola.com</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigureAddressCollectionPreview;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionPreview/ConfigureAddressCollectionPreview.tsx